import React from "react";
import { Link } from "react-router-dom";

import DrawerToggleButton from "./DrawerToggleButton";
import Backdrop from "./Backdrop";
import SideDrawer from "./SideDrawer";
import EmailSubmit from "./EmailSubmit";
import "../styles/Toolbar.css";

const Toolbar = (props) => (
  <header className="toolbar">
    <nav className="toolbar__navigation">
      <div className="toolbar__toggle-button">
        <DrawerToggleButton click={props.drawerClickHandler} />
      </div>
      <div className="toolbar__logo">
        <a href="/"> </a>
      </div>
      <div className="spacer" />
      <div className="toolbar_navigation-items">
        <ul>
          <li>
            <Link to="/">Calculator</Link>
          </li>
          <li>
            <Link to="/guide">Instructions</Link>
          </li>
        </ul>
      </div>
      <EmailSubmit />
    </nav>
  </header>
);

class ToolBarWrapper extends React.Component {
  state = {
    sideDrawerOpen: false,
  };

  drawerToggleClickHandler = () => {
    this.setState((prevState) => {
      return { sideDrawerOpen: !prevState.sideDrawerOpen };
    });
  };

  backdropClickHandler = () => {
    this.setState({ sideDrawerOpen: false });
  };

  render() {
    let backdrop;

    if (this.state.sideDrawerOpen) {
      backdrop = <Backdrop click={this.backdropClickHandler} />;
    }
    return (
      <div style={{ height: "100%" }}>
        <Toolbar drawerClickHandler={this.drawerToggleClickHandler} />
        {/* Ad placement: needs real dimensions before it can be re-enabled.
        <div style={{ width: "728px", height: "90px" }}>
          <ins
            className="epn-placement"
            data-config-id="001af6f7f0436f0a325ccde3"
          ></ins>
        </div> */}
        {/*<SideDrawer show={this.state.sideDrawerOpen} /> */}
        {backdrop}
      </div>
    );
  }
}

export default ToolBarWrapper;


// Navbar for the pages that render LeftSideBar (Layout, RNG). The newsletter
// signup lives in that sidebar now, so this is just the top chrome.
export function ToolBar(props) {
  // TODO: Rewrite all this with style components ex: "styled.div`blah`"
  const toolbarStyle = {
    minWidth: "100%",
    minHeight: "75%",
    display: "flex",
    alignItems: "center",
    // Matches the wordmark block in LeftSideBar so the top row reads as one bar.
    background: "#1f2122",
  };

  return <div style={toolbarStyle} />;
}
